module.exports = __webpack_public_path__ + "static/media/sin_servicios.acd49595.svg";